export default __webpack_public_path__ + "static/media/WhatsApp Image 2026-01-14 at 6.32.47 PM.ebcaa1ec.jpeg";